import { render, staticRenderFns } from "./VehicleGroupDetailDialog.vue?vue&type=template&id=6ef5f5d0&scoped=true"
import script from "./VehicleGroupDetailDialog.vue?vue&type=script&lang=js"
export * from "./VehicleGroupDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./VehicleGroupDetailDialog.vue?vue&type=style&index=0&id=6ef5f5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5f5d0",
  null
  
)

export default component.exports